import * as React from "react";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DomAttribute } from "@bizform/type/model/dom/DomAttribute.model";
import { Debug, FunctionHelper } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";


type Props =  {
};

type State =  {
    show: boolean;
    customId: string,
    customHtml: string;
};

/**
 * Custom Html Panel
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<null>>()
export class BfCustomHtmlPanel extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.CUSTOMHTMLHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_RcHc91JFuTxpWTDuAy7CQBbaFKUCBgB",
        category: ComponentCategory.HANDLER,
        label: "Custom HTML Panel",
        description: "Custom HTML Panel",
        icon: "",
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    parentDom: HTMLElement;

    /** action */
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    focus() {}

    readyComponent() {}

    setProperty(property: ComponentElementProperty) {
        try {
            this.setState({
                show: this.state.show,
                customId: property && property.attribute && property.attribute.customId &&  property.attribute.customId.value ? property.attribute.customId.value : "",
                customHtml: property && property.attribute && property.attribute.customHtml &&  property.attribute.customHtml.value ? property.attribute.customHtml.value : ""
            });
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfCustomHtmlPanel)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    emitHasContainerKey(): void {
    }

    /* for React */
    props: Props;
    state: State;

    static defaultProps = {
    };

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false,
            customId: "",
            customHtml:  ""
        };
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return this.state.show !== nextState.show || this.state.customId !== nextState.customId || this.state.customHtml !== nextState.customHtml;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.state.show) {
            return null;
        } else {
            this._customHtmlExecute(this.state.customHtml).then();
            const attr = {
                [DomAttribute.CUSTOMID]: this.state.customId
            };
            return (
                <div dangerouslySetInnerHTML={{__html: this.state.customHtml}}{...attr}></div>
            );
        }
    }

    private async _customHtmlExecute(content: string): Promise<void> {
        if (content) {
            await FunctionHelper.timeout(100);
            FunctionHelper.customHtmlExecute(content);
        }
        await FunctionHelper.timeout();
        this.readyComponent();
    }

    private _show() {
        this.setState({
            show: true
        });
    }
}
